export default __webpack_public_path__ + "static/media/logo-text.15fa93dd.svg";